export default {
  computed: {
    /*
     * Default empty filter array
     */
    events () {
      return []
    }
  },

  mounted () {
    this.events.forEach(this.addEventListener)
  },

  beforeDestroy () {
    this.events.forEach(this.removeEventListener)
  },

  methods: {
    addEventListener ({ element = document, name, handler }) {
      element && element.addEventListener(name, handler)
    },

    removeEventListener ({ element = document, name, handler }) {
      element && element.removeEventListener(name, handler)
    }
  }
}
